export const getMonthBoundariesInUTC = (
  initialMonth?: number,
  finalMonth?: number,
  isPresentDay?: boolean
) => {
  const dateNow = new Date()
  const yearCurrent = dateNow.getUTCFullYear()
  const monthCurrent = dateNow.getUTCMonth()
  const dayCurrent = dateNow.getUTCDate()

  const newInitialMonth = initialMonth ?? monthCurrent
  const newFinalMonth = finalMonth ?? monthCurrent

  const firstDateUTC = new Date(
    Date.UTC(yearCurrent, newInitialMonth, 1, 0, 0, 0, 0)
  )

  const lastDateUTC = new Date(
    !isPresentDay
      ? Date.UTC(yearCurrent, newFinalMonth + 1, 0, 23, 59, 59, 999)
      : Date.UTC(yearCurrent, newFinalMonth, dayCurrent, 23, 59, 59, 999)
  )

  return {
    firstDate: firstDateUTC.toISOString(),
    lastDate: lastDateUTC.toISOString(),
  }
}
